export function usePage(props, route) {
  function showContentOverlay() {
    return false
  }

  return {
    showContentOverlay,
  }
}
